import Vue from 'vue'
import appConfig from '@/config.js'

const shippingsInContainerModel = vm => ({
  title: vm.$gettext('Shippings In Container'),
  endpoint: null,
  fields: [
    {
      key: 'shipping_id',
      label: vm.$gettext('ID'),
      sortable: true,
      formatter: (value, key, item) => {
        if (item.id) {
          return (
            '<a href="/edit/shippings/' +
            item.id +
            '" target="_blank">' +
            Vue.options.filters.uuid(item.id) +
            '</a>'
          )
        }
      }
    },
    {
      key: 'company_id',
      sortable: false,
      label: vm.$gettext('Posted by'),
      formatter: (value, key, item) => {
        return item.company ? item.company.name : ''
      }
    },
    {
      key: 'status',
      label: vm.$gettext('Status'),
      sortable: true
    },
    {
      key: 'sla_date',
      sortable: true,
      label: vm.$gettext('SLA')
    }
  ],
  extraActions: [
    {
      label: vm.$gettext('Remove'),
      type: 'button',
      icon: 'trash-alt',
      title: vm.$gettext('Remove Shipping from Container'),
      variant: 'danger',
      position: 'end',
      disabledCondition: item => {
        return item.shippings_container[0].status !== 'DRAFT'
      },
      action: item => {
        if (confirm(vm.$gettext('Are you sure you want to REMOVE the Shipping from this Container?'))) {
          const payload = {
            body: {
              shippings: [item.id]
            }
          }
          Vue.http
            .delete(
              appConfig.api.baseUrl + 'shippings-containers/' + item.shippings_container[0].id + '/shippings',
              payload
            )
            .then(response => {
              vm.$root.$emit('reloadItem')
            })
        }
      }
    }
  ],
  filters: [],
  includes: []
})

export default shippingsInContainerModel
